import { Expression } from '../generated/types'

export function emptyExpression(): Expression {
    return { extType: 'kibsi', plainText: '' }
}
